import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

const ALLOWED = ["architecture-3d.html", "architecture-diagrams.html", "ads-diagrams.html", "deployment-guide.html", "testing-strategy.html", "test-coverage.html", "data-model.html", "kpi-formulas.html"];

export default function DocViewerPage() {
  const { filename } = useParams();
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ALLOWED.includes(filename)) {
      setError("Document not found");
      return;
    }
    fetch(`/docs/${filename}`)
      .then((r) => (r.ok ? r.text() : Promise.reject("Not found")))
      .then(setHtml)
      .catch(() => setError("Failed to load document"));
  }, [filename]);

  if (error) return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <p>{error}</p>
      <button onClick={() => navigate(-1)} style={{ marginTop: 16, padding: "8px 20px", cursor: "pointer" }}>
        Go Back
      </button>
    </div>
  );

  if (!html) return <div style={{ padding: 40, textAlign: "center" }}>Loading...</div>;

  return (
    <iframe
      ref={iframeRef}
      srcDoc={html}
      title={filename}
      style={{ width: "100%", height: "100vh", border: "none" }}
      sandbox="allow-scripts allow-same-origin"
    />
  );
}
